import AppDispatcher from "../Dispatcher";
import { AppActionConstants } from "./AppActionConstants";
import AppConfig from "../../AppConfig";
import { fetchWithAuthGet } from "../FetchWithAuth";
import BookFiltersStore from "../Stores/BookFiltersStore";

const Book2 = AppConfig.getBookApiBasePath();

export const fetchCurrencySymbols = () => {
	const contextValues = BookFiltersStore.getContextValues();
	return fetchWithAuthGet(`${Book2.ApiBasePath}/plook/MasterCountryView/GetCountryCurrencySymbols/${contextValues?.country?.name}`)
		.then((response) => {
			const symbol = response[0].Symbol;
			AppDispatcher.dispatch({
				type: AppActionConstants.fetchCurrencySymbols,
				value: symbol
			});
		})
		.catch(() => {
			console.log("error");
		});
};

export const fetchSyncStatuses = () => {
	const contextValues = BookFiltersStore.getContextValues();
	return fetchWithAuthGet(
		`${Book2.ApiBasePath}/plook/PlatformAccount/GetPlatformAccountAPIConfigurationsByACRC/${contextValues.contextId}/${contextValues.agency.name}/${contextValues.client.name}/${contextValues.region.name}/${contextValues.country.name}`
	)
		.then((response) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.fetchSyncStatusesSuccess,
				value: response
			});
		})
		.catch(() => {
			console.log("error");
		});
};

export const getPrismaFinancials = (campaignID) => {
	return fetchWithAuthGet(`${Book2.ApiBasePath}/plook/Campaign/GetPrismaCampaignFinancials/${campaignID}`);
};

export const putFilterData = (name, value) => {
	AppDispatcher.dispatch({
		type: AppActionConstants.putFilters, // "PUTFILTERS"
		value,
		name
	});
};

export const addAllAarcValues = () => {
	return fetchWithAuthGet(`${Book2.ApiBasePath}/plook/costformula/get`).then((response) => {
		AppDispatcher.dispatch({
			type: AppActionConstants.addAllAarcValues,
			value: "",
			formulas: response
		});
	});
};

export const parseContextData = (context, contextId) => {
	const client = {
		id: context.id,
		name: context.name
	};
	const agency = {};
	const region = {};
	const country = {};
	let matchingContextIDFound = false;
	if (context.id === contextId) {
		matchingContextIDFound = true;
	} else {
		context.contexts?.forEach((contextAgency) => {
			if (matchingContextIDFound !== true) {
				if (contextAgency.id === contextId) {
					matchingContextIDFound = true;
					agency.id = contextAgency.id;
					agency.name = contextAgency.name;
				} else {
					contextAgency.contexts.forEach((contextRegion) => {
						if (matchingContextIDFound !== true) {
							if (contextRegion.id === contextId) {
								matchingContextIDFound = true;
								agency.id = contextAgency.id;
								agency.name = contextAgency.name;
								region.id = contextRegion.id;
								region.name = contextRegion.name;
							} else {
								contextRegion.contexts.forEach((contextCountry) => {
									if (matchingContextIDFound !== true) {
										if (contextCountry.id === contextId) {
											agency.id = contextAgency.id;
											agency.name = contextAgency.name;
											region.id = contextRegion.id;
											region.name = contextRegion.name;
											country.id = contextCountry.id;
											country.name = contextCountry.name;
										}
									}
								});
							}
						}
					});
				}
			}
		});
	}

	return {
		client,
		agency,
		region,
		country,
		contextId
	};
};

export const storeContextData = (contextId, context) => {
	if (context && contextId) {
		AppDispatcher.dispatch({
			type: AppActionConstants.storeContextValues,
			value: parseContextData(context, contextId)
		});
	}
};
